var $390d441203d25ff4$exports = {};
$390d441203d25ff4$exports = {
    "close": `Luk`,
    "notifications": `P\xe5mindelser`
};


export {$390d441203d25ff4$exports as default};
//# sourceMappingURL=da-DK.module.js.map
